/* 🤖 this file was generated by svg-to-ts */
export const siriusCircleHalfTilt: {
  name: 'circle_half_tilt';
  data: string;
} = {
  name: 'circle_half_tilt',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.884 19.026a.807.807 0 0 0 .09.09A9.968 9.968 0 0 0 12 22c5.523 0 10-4.477 10-10 0-2.738-1.1-5.22-2.883-7.025a.844.844 0 0 0-.092-.092A9.968 9.968 0 0 0 12 2C6.477 2 2 6.477 2 12c0 2.739 1.1 5.22 2.884 7.026ZM3.538 12a8.462 8.462 0 0 1 13.877-6.503L5.497 17.415A8.427 8.427 0 0 1 3.538 12Zm14.965-5.415A8.461 8.461 0 0 1 6.586 18.502L18.501 6.586Z" fill="currentColor"/></svg>`
};
